import { ITicket } from '@sv-support-sdk/shared-types/src/common/tickets';

import { $l } from '../locales';
import { STATUS_REVIEW } from '../constants/ticketStatuses';

export const getTicketStatus = (
  ticket: ITicket,
  closedAt: string | null,
): {
  icon: string;
  children: string;
  color?: 'orange';
} => {
  const lastMessageAuthorType =
    ticket.messages && ticket.messages.length > 0
      ? ticket.messages[ticket.messages.length - 1].author.type
      : ticket.lastMessage && ticket.lastMessage.author.type;

  if (closedAt) return { icon: '12--success', children: $l('TICKETS.RESOLVED') };

  if (ticket.status === STATUS_REVIEW) {
    return {
      icon: '12--arrow-in-circle',
      color: 'orange',
      children: $l('TICKETS.WAITING_FOR_DEVELOPMENT'),
    };
  }

  const isLastMessageFromSupport =
    lastMessageAuthorType && lastMessageAuthorType.toLowerCase() === 'staff';

  return {
    icon: '12--arrow-in-circle',
    color: 'orange',
    children: isLastMessageFromSupport
      ? $l('TICKETS.WAITING_FOR_CUSTOMER')
      : $l('TICKETS.WAITING_FOR_SUPPORT'),
  };
};
